<template>
    <b-modal id="product_unit_delete" ref="product_unit_delete" header-class="no-border" footer-class="no-border"
             :title="'Delete ' + floor.data.attributes.name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('floor_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteProductUnit">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
    import StateButton from "../../../../../components/Common/StateButton";


    export default {
        name: "ProductUnitsDeleteModal",

        components: {
            StateButton,
        },

        props: [
            'product_unit'
        ],

        methods: {
            hideModal(refname) {
                this.$refs[refname].hide();
            },

            deleteProductUnit() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteProductUnit', this.product_unit)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('error filled', 'Success!', 'Deleted the product unit!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_unit_delete');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        }
    }
</script>

<style scoped>

</style>
